import Post, {IPost} from '@/models/Post'
import Tag from '@/models/Tag'
import PageBase from '@/pages/page-base'

export default abstract class PostBase extends PageBase {
  post = new Post()
  tags: Array<Tag> = []
  targetPath: string
  tagCategory = 'keyword_cat'

  async onPreview(): Promise<void> {
    window.open('', 'preview')

    const form: HTMLFormElement = document.createElement('form')
    form.action = this.post.previewLink
    form.method = 'POST'
    form.target = 'preview'

    const previewParams = this.previewParams
    Object.keys(previewParams).forEach((name) => {
      form.appendChild(this.createInputElement(name, previewParams[name]))
    })

    const params = this.post.toParams()
    form.appendChild(this.createInputElement('preview', JSON.stringify(params)))

    document.body.appendChild(form)
    form.submit()
    document.body.removeChild(form)
  }

  toFrontModel(data: IPost): Post {
    return new Post(data)
  }

  createInputElement(name: string, value: string, type= 'hidden'): HTMLInputElement {
    const element: HTMLInputElement = document.createElement('input')
    element.type = type
    element.name = name
    element.value = value
    return element
  }

  mounted(): void {
    super.mounted()
  }
}
